import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "../features/auth/authSlice";
import userPositionDataReducer from "../features/users/userPositionDataSlice";
import obracuniKeyDataReducer from "../features/obracuni/obracuniKeyDataSlice";
import transformacije from "../features/transformacije/PokreniTransformaciju";
import tranzicije from "../components/TransitionSlice";

// import devToolsEnhancer from "remote-redux-devtools"; //Fix da se enabluje redux

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    userDataPositions: userPositionDataReducer,
    obracuniKeyData: obracuniKeyDataReducer,
    transformacijaData: transformacije,
    tranzicijaData: tranzicije,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true, //OVO JE PRAVI FIX ZA PRIKAZIVANJE REDUXA
  //Fix za
});

// export const store = configureStore({
//   reducer: {
//     [apiSlice.reducerPath]: apiSlice.reducer,
//     auth: authReducer,
//     userDataPositions: userPositionDataReducer,
//     obracuniKeyData: obracuniKeyDataReducer,
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().concat(apiSlice.middleware),
//   // Apply devToolsEnhancer here
//   enhancers: [
//     // Ensure devToolsEnhancer is included only once
//     process.env.NODE_ENV !== "production" && devToolsEnhancer(),
//   ].filter(Boolean),
// });

setupListeners(store.dispatch);
